import { render, staticRenderFns } from "./InviteLinkDialog.vue?vue&type=template&id=81ce62e6&scoped=true"
import script from "./InviteLinkDialog.vue?vue&type=script&lang=js"
export * from "./InviteLinkDialog.vue?vue&type=script&lang=js"
import style0 from "./InviteLinkDialog.vue?vue&type=style&index=0&id=81ce62e6&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81ce62e6",
  null
  
)

export default component.exports